export class RecommendationModel {
    Title:string;
    RecommendedId: number;
    RecommendedUrl: string;
    RecommendedtoEmail: string;
    RecommendedbyUserId: number;

}
